import React from 'react';

export function DashboardCard({
  children,
  className = '',
  style,
  hoverLift = true,
  securityLevel,
}) {
  const securityClass =
    securityLevel === 'high'
      ? 'premium-panel--security-high'
      : securityLevel === 'medium'
        ? 'premium-panel--security-medium'
        : securityLevel === 'low'
          ? 'premium-panel--security-low'
          : '';

  const lift = hoverLift
    ? 'hover:-translate-y-1 hover:shadow-lg hover:border-indigo-200/60 dark:hover:border-indigo-500/30 dark:hover:shadow-indigo-500/5'
    : '';

  return (
    <div
      style={style}
      className={`
        premium-panel rounded-2xl border border-gray-200/80 bg-white/90 p-6 shadow-sm backdrop-blur-sm
        transition-all duration-300 ease-[cubic-bezier(0.22,1,0.36,1)]
        dark:border-slate-700/60 dark:bg-slate-800/90 dark:shadow-md dark:shadow-slate-900/20
        ${lift} ${securityClass} ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      {children}
    </div>
  );
}

export default DashboardCard;
